let offers;
let theProduct;
let cart;
let cartJson;
let addToCartButtonClicked = false;

/**
 * Warranty/cart variant sync guards
 */
let isMulberryWarrantySyncing = false;
let cartVariantWarrantySyncToken = 0;
let cartVariantWarrantySyncQueue = Promise.resolve();
let ignoreCartEventsUntil = 0;
let lastKachingCartUpdateAt = 0;

const KACHING_CART_UPDATE_COOLDOWN_MS = 2000;
const MULBERRY_CART_EVENT_IGNORE_MS = 1500;

const MULBERRY_PROTECTION_HANDLE_PREFIX = 'mulberry-protection';

let cartVariantWarrantySyncPendingUntil = 0;

const CART_VARIANT_WARRANTY_SYNC_PENDING_MS = 7000;

function protectVariantWarrantySyncWindow() {
  const until = Date.now() + CART_VARIANT_WARRANTY_SYNC_PENDING_MS;

  ignoreCartEventsUntil = Math.max(ignoreCartEventsUntil, until);
  cartVariantWarrantySyncPendingUntil = Math.max(cartVariantWarrantySyncPendingUntil, until);
}

function markCartVariantWarrantySyncPending() {
  cartVariantWarrantySyncPendingUntil = Date.now() + CART_VARIANT_WARRANTY_SYNC_PENDING_MS;
}

function isCartVariantWarrantySyncPending() {
  return Date.now() < cartVariantWarrantySyncPendingUntil;
}

function wait(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

function getCurrentlySelectedVariant(product) {
  mulberryShop.selectedVariantId = mulberryShop.selectedVariantId;

  let selectedVariant = product.variants.find(
    (i) => i.id == mulberryShop.selectedVariantId
  );

  if (!selectedVariant) {
    selectedVariant = product.variants[0];
  }

  let priceEl = document.querySelector('.single-product-price');

  if (priceEl) {
    let price = Number(priceEl.textContent.replace(/[^\d.]/g, ''));
    price = Number.isNaN(price) ? null : price.toFixed(2);

    if (price) {
      selectedVariant.price = price.toString();
    }
  } else {
    priceEl = document.querySelector('#payment-price');

    if (priceEl) {
      let price = Number(priceEl.textContent.replace(/[^\d.]/g, ''));
      price = Number.isNaN(price) ? null : price.toFixed(2);

      if (price) {
        selectedVariant.price = price.toString();
      }
    }
  }

  return selectedVariant;
}

async function mulberryPdpInit() {
  const HAS_MODAL = mulberry.core.settings.has_modal;
  const HAS_INLINE = false; // mulberry.core.settings.has_inline || true;

  if (window.location.pathname.indexOf("/products/") === -1) {
    return;
  }

  if (!HAS_MODAL && !HAS_INLINE) {
    return;
  }

  let response = await mulberryShop.getProductData(
    mulberryShop.getProductUrl()
  );

  theProduct = response.product;

  let selectedVariant = getCurrentlySelectedVariant(theProduct);

  offers = await mulberry.core.getWarrantyOffer({
    id: selectedVariant.id,
    title: theProduct.title,
    price: selectedVariant.price,
    detail: theProduct,
  });

  if (HAS_INLINE) {
    window.pdpInline = await mulberry.inline.init({
      offers: offers,
      settings: mulberry.core.settings,
      selector: ".mulberry-pdp-inline",
      layout: {
        faq: false,
      },
      onWarrantyToggle: async (warranty) => {
        mulberry.inline.isSelected = warranty.isSelected;

        if (warranty.isSelected) {
          window.selectedOffer = warranty;
        } else {
          window.selectedOffer = null;
        }
      },
    });

    mulberry.faq.init({
      coverage: mulberry.core.offers[0],
      settings: mulberry.core.settings
    });

    document.querySelector("#whats-covered-faq")?.removeAttribute("style");

    document.querySelector("#whats-covered-faq")?.addEventListener("click", function () {
      mulberry.faq.open();
    });
  }

  if (HAS_MODAL) {
    window.pdpModal = await mulberry.modal.init({
      offers: offers,
      settings: mulberry.core.settings,
      onWarrantySelect: async (warranty) => {
        const result = await mulberryShop.getWarrantyVariant(warranty);

        await mulberryShop.addWarrantyToCart(
          result.shopify_variant_id,
          theProduct,
          warranty
        );

        mulberry.modal.close();
      },
      onWarrantyDecline: async () => {
        mulberry.modal.close();
        window.kachingCartApi.openCart();
      },
    });
  }
}

document
  ?.querySelector(".add-to-cart__button")
  ?.addEventListener("click", async function (e) {
    e.preventDefault();

    const HAS_MODAL = mulberry.core.settings.has_modal;
    const HAS_INLINE = false; // mulberry.core.settings.has_inline || true;

    const spinner = this.querySelector(".loading__spinner");

    if (spinner) {
      spinner.classList.remove("hidden");
    }

    this.disabled = true;

    const handleClick = async () => {
      if (HAS_INLINE && window.selectedOffer && window.pdpInline) {
        await addWarranty();
      } else if (HAS_MODAL && !window.selectedOffer && window.pdpModal) {
        window.pdpModal.open();
      } else {
        window.kachingCartApi.openCart();
      }
    };

    await Promise.resolve().then(handleClick);

    this.disabled = false;
  });

async function addWarranty() {
  addToCartButtonClicked = true;

  if (!offers || offers.length == 0) {
    return;
  }

  try {
    let result;

    cart = await fetch("/cart.js");
    cartJson = await cart.json();

    if (window.selectedOffer) {
      result = await mulberryShop.getWarrantyVariant(
        window.selectedOffer.offer
      );

      await mulberryShop.addWarrantyToCart(
        result.shopify_variant_id,
        {
          ...theProduct,
          title: theProduct.title,
          variantId: mulberryShop.selectedVariantId,
        },
        window.selectedOffer.offer
      );

      window.pdpInline.deselectOffer();
      window.selectedOffer = null;
    }
  } catch (err) {
    console.log("mulberry error: ", err);
  }

  mulberry.inline.deselectOffer();
}

document.addEventListener('mulberry-shopify:warranty-added', async (e) => {
  // await removeAndSyncWarranties();
});

document.addEventListener("mulberry-shopify:loaded", async function (e) {
  window.mb_gtm_is_disabled = true;

  setupFetchListeners();

  if (document.location.href.includes("/products/")) {
    await mulberryPdpInit();
  }

  let theVariant;
  let variantChangeToken = 0;
  let variantRefreshTimer;
  let lastKnownVariantId = '';

  function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);

    return results === null
      ? ''
      : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  function getCurrentVariantId() {
    return (
      getUrlParameter('variant') ||
      document
        .querySelector('.check-all-temp')
        ?.closest('form')
        ?.querySelector('[name="id"]')
        ?.value ||
      ''
    );
  }

  async function handleUrlChange(force = false) {
    var variant = getCurrentVariantId();

    if (variant && (force || theVariant !== variant)) {
      const token = ++variantChangeToken;

      theVariant = variant;

      window.selectedOffer = null;

      if (window.pdpInline) {
        window.pdpInline.deselectOffer();
      }

      mulberryShop.selectedVariantId = variant;

      await wait(900);

      if (token !== variantChangeToken) {
        return;
      }

      let selectedVariant = getCurrentlySelectedVariant(theProduct);

      offers = await mulberry.core.getWarrantyOffer({
        id: selectedVariant.id,
        title: theProduct.title,
        price: selectedVariant.price,
        detail: theProduct,
      });

      if (offers && offers.length) {
        if (mulberry.core.settings.has_inline && window.pdpInline) {
          window.pdpInline.updateOffer(offers);
        }

        if (mulberry.core.settings.has_modal) {
          window.pdpModal.updateOffer(offers);
        }
      } else {
        // No PDP warranty offer for this variant.
      }
    }
  }

  function triggerVariantRefresh(force = false) {
    clearTimeout(variantRefreshTimer);

    variantRefreshTimer = setTimeout(() => {
      handleUrlChange(force);
    }, 50);
  }

  function patchHistoryChange() {
    if (window.__mulberryHistoryPatched) return;

    window.__mulberryHistoryPatched = true;

    ['pushState', 'replaceState'].forEach(function (method) {
      const original = history[method];

      history[method] = function () {
        const result = original.apply(this, arguments);

        window.dispatchEvent(new Event('mulberry:urlchange'));

        return result;
      };
    });

    window.addEventListener('popstate', function () {
      window.dispatchEvent(new Event('mulberry:urlchange'));
    });
  }

  patchHistoryChange();

  window.addEventListener('mulberry:urlchange', function () {
    triggerVariantRefresh(false);
  });

  lastKnownVariantId = getCurrentVariantId();

  if (!window.__mulberryVariantWatcherStarted) {
    window.__mulberryVariantWatcherStarted = true;

    setInterval(function () {
      const currentVariantId = getUrlParameter('variant') || '';

      if (currentVariantId && currentVariantId !== lastKnownVariantId) {
        lastKnownVariantId = currentVariantId;
        triggerVariantRefresh(true);
      }
    }, 300);
  }

  handleUrlChange(true);
});

document.addEventListener("fetch:cart-change", async function () {
  if (isMulberryWarrantySyncing) return;

  await removeAndSyncWarranties();
});

document.addEventListener("fetch:cart-add", async function () {
  // await removeAndSyncWarranties();
});

document.addEventListener("fetch:cart-update", async function () {
  await removeAndSyncWarranties();
});

async function removeAndSyncWarranties(reload = false) {
  if (isMulberryWarrantySyncing) return;

  isMulberryWarrantySyncing = true;

  try {
    let response = await fetch('/cart.js', {
      credentials: 'same-origin',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    let firstCart = await response.json();

    firstCart.items = firstCart.items.filter(
      item => item?.properties?._variantId !== 'sectional'
    );

    const newCart = await mulberryShop.removeDetachedWarranty(firstCart);
    await mulberryShop.cart.syncQuantities(newCart);

  } catch (error) {
    console.error('Error during warranty removal and cart sync:', error);
  } finally {
    ignoreCartEventsUntil = Date.now() + MULBERRY_CART_EVENT_IGNORE_MS;
    isMulberryWarrantySyncing = false;
  }
}

/**
 * -------------------------------------------------------------------------
 * CART VARIANT CHANGE -> WARRANTY REPLACE LOGIC
 * -------------------------------------------------------------------------
 */

function safeJsonParse(value) {
  try {
    return JSON.parse(value);
  } catch (error) {
    return null;
  }
}

async function bodyToText(body) {
  if (!body) return '';

  if (typeof body === 'string') {
    return body;
  }

  if (body instanceof URLSearchParams) {
    return body.toString();
  }

  if (body instanceof FormData) {
    return '';
  }

  if (body instanceof Blob) {
    return await body.text();
  }

  if (body instanceof ArrayBuffer) {
    return new TextDecoder().decode(body);
  }

  return '';
}

async function getFetchRequestInfo(args) {
  const input = args[0];
  const init = args[1] || {};

  let requestUrl = '';
  let requestBody = '';

  if (typeof input === 'string' || input instanceof URL) {
    requestUrl = String(input);
  } else if (input && typeof input.url === 'string') {
    requestUrl = input.url;
  }

  if (init && init.body != null) {
    requestBody = await bodyToText(init.body);
  } else if (input && typeof input.clone === 'function') {
    try {
      requestBody = await input.clone().text();
    } catch (error) {
      requestBody = '';
    }
  }

  return {
    requestUrl,
    requestBody
  };
}

function isVariantBySelectedOptionsRequest(requestUrl, requestBody) {
  if (!requestUrl || !requestBody) return false;

  return (
    requestUrl.includes('/graphql') &&
    requestBody.includes('variantBySelectedOptions') &&
    requestBody.includes('selectedOptions')
  );
}

function extractShopifyNumericId(value) {
  if (!value) return '';

  const stringValue = String(value);

  if (/^\d+$/.test(stringValue)) {
    return stringValue;
  }

  const match = stringValue.match(/\/(\d+)(?:\?|$)/);

  return match ? match[1] : stringValue.split('/').pop();
}

function getCartLineProductHandle(item) {
  return (
    item?.handle ||
    item?.product_handle ||
    item?.url?.match(/\/products\/([^/?]+)/)?.[1] ||
    ''
  );
}

function isMulberryWarrantyLine(item) {
  const handle = getCartLineProductHandle(item);
  const title = String(item?.product_title || item?.title || '').toLowerCase();
  const properties = item?.properties || {};

  return (
    handle.startsWith(MULBERRY_PROTECTION_HANDLE_PREFIX) ||
    title.includes('mulberry protection') ||
    properties._warranty_duration_months != null ||
    properties.warranty_duration_months != null
  );
}

function getPropertyValue(properties, keys) {
  if (!properties) return null;

  for (const key of keys) {
    if (properties[key] != null && properties[key] !== '') {
      return properties[key];
    }
  }

  return null;
}

function extractDurationMonths(value) {
  if (value == null || value === '') return null;

  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }

  const stringValue = String(value).trim();

  let match = stringValue.match(/(\d+)\s*(?:years|year|yrs|yr)/i);

  if (match) {
    return Number(match[1]) * 12;
  }

  match = stringValue.match(/(\d+)\s*(?:months|month|mos|mo)/i);

  if (match) {
    return Number(match[1]);
  }

  if (/^\d+$/.test(stringValue)) {
    const numberValue = Number(stringValue);

    if (numberValue > 0 && numberValue <= 240) {
      return numberValue;
    }
  }

  return null;
}

function getWarrantyDurationMonthsFromLine(item) {
  const properties = item?.properties || {};

  const directValue = getPropertyValue(properties, [
    '_warranty_duration_months',
    'warranty_duration_months',
    '_duration_months',
    'duration_months',
    'durationMonths',
    '_term_months',
    'term_months',
    'termMonths'
  ]);

  const directDuration = extractDurationMonths(directValue);

  if (directDuration) {
    return directDuration;
  }

  return extractDurationMonths(
    [
      item?.variant_title,
      item?.title,
      item?.product_title
    ].filter(Boolean).join(' ')
  );
}

function getWarrantyDurationMonthsFromOffer(offer) {
  const possibleObjects = [
    offer,
    offer?.offer,
    offer?.warranty,
    offer?.coverage,
    offer?.metadata
  ].filter(Boolean);

  const durationKeys = [
    '_warranty_duration_months',
    'warranty_duration_months',
    '_duration_months',
    'duration_months',
    'durationMonths',
    '_term_months',
    'term_months',
    'termMonths',
    'months'
  ];

  const textKeys = [
    'title',
    'name',
    'label',
    'description',
    'term',
    'plan_title',
    'planTitle'
  ];

  for (const obj of possibleObjects) {
    for (const key of durationKeys) {
      const duration = extractDurationMonths(obj?.[key]);

      if (duration) {
        return duration;
      }
    }

    for (const key of textKeys) {
      const duration = extractDurationMonths(obj?.[key]);

      if (duration) {
        return duration;
      }
    }
  }

  return null;
}

function getWarrantyParentVariantId(item) {
  const properties = item?.properties || {};

  const value = getPropertyValue(properties, [
    '_variantId',
    '_variant_id',
    '_parent_variant_id',
    'parent_variant_id',
    'variantId',
    'variant_id'
  ]);

  return value ? String(value) : '';
}

function getWarrantyParentProductId(item) {
  const properties = item?.properties || {};

  const value = getPropertyValue(properties, [
    '_productId',
    '_product_id',
    '_parent_product_id',
    'parent_product_id',
    'productId',
    'product_id'
  ]);

  return value ? String(value) : '';
}

function findParentProductLine(cartJson, productId, variantId = '') {
  const numericProductId = String(productId || '');
  const numericVariantId = String(variantId || '');

  const productLines = (cartJson?.items || []).filter((item) => {
    if (isMulberryWarrantyLine(item)) return false;

    return String(item.product_id) === numericProductId;
  });

  if (numericVariantId) {
    const exactVariantLine = productLines.find((item) => {
      return String(item.variant_id) === numericVariantId;
    });

    if (exactVariantLine) {
      return exactVariantLine;
    }
  }

  return productLines[0] || null;
}

function findRelatedWarrantyLines(cartJson, parentProductLine, productId) {
  const warrantyLines = (cartJson?.items || []).filter(isMulberryWarrantyLine);

  if (!warrantyLines.length) {
    return [];
  }

  const parentVariantId = parentProductLine?.variant_id
    ? String(parentProductLine.variant_id)
    : '';

  const parentProductId = productId ? String(productId) : '';

  const related = warrantyLines.filter((item) => {
    const warrantyParentVariantId = getWarrantyParentVariantId(item);
    const warrantyParentProductId = getWarrantyParentProductId(item);

    return (
      Boolean(parentVariantId && warrantyParentVariantId === parentVariantId) ||
      Boolean(parentProductId && warrantyParentProductId === parentProductId)
    );
  });

  if (related.length) {
    return related;
  }

  /**
   * Safe fallback:
   * If the cart only has one warranty line, treat it as the attached warranty.
   * This avoids breaking common one-product mattress cart flows.
   */
  if (warrantyLines.length === 1) {
    return warrantyLines;
  }

  return [];
}

async function getCartJson() {
  const response = await fetch('/cart.js', {
    credentials: 'same-origin',
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  });

  return await response.json();
}

async function removeCartLineByKey(lineKey) {
  if (!lineKey) return;

  await fetch('/cart/change.js', {
    credentials: 'same-origin',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({
      id: lineKey,
      quantity: 0
    })
  });
}

async function removeWarrantyLines(warrantyLines) {
  for (const item of warrantyLines) {
    await removeCartLineByKey(item.key);
    await wait(120);
  }
}

async function waitForCartVariant(productId, variantId, timeoutMs = 4000) {
  const startedAt = Date.now();

  while (Date.now() - startedAt < timeoutMs) {
    const latestCart = await getCartJson();

    const matchedLine = findParentProductLine(
      latestCart,
      productId,
      variantId
    );

    if (matchedLine) {
      return {
        cartJson: latestCart,
        productLine: matchedLine
      };
    }

    await wait(250);
  }

  const fallbackCart = await getCartJson();

  return {
    cartJson: fallbackCart,
    productLine: findParentProductLine(fallbackCart, productId)
  };
}

function getGraphqlSelectedOptionsLabel(variantFromGraphql) {
  return (variantFromGraphql?.selectedOptions || [])
    .map((option) => option.value)
    .filter(Boolean)
    .join(' / ');
}

function getGraphqlVariantPrice(variantFromGraphql, fallbackLine) {
  const graphqlAmount = variantFromGraphql?.price?.amount;

  if (graphqlAmount != null && graphqlAmount !== '') {
    const numberAmount = Number(graphqlAmount);

    if (!Number.isNaN(numberAmount)) {
      return numberAmount.toFixed(2);
    }
  }

  if (fallbackLine?.final_price != null) {
    return (Number(fallbackLine.final_price) / 100).toFixed(2);
  }

  if (fallbackLine?.price != null) {
    return (Number(fallbackLine.price) / 100).toFixed(2);
  }

  return '0.00';
}

async function getProductDetailForCartLine(productLine, productId) {
  /**
   * If PDP product data is already the same product, reuse it.
   */
  if (
    theProduct &&
    (
      String(theProduct.id) === String(productId) ||
      String(theProduct.product_id) === String(productId)
    )
  ) {
    return { ...theProduct };
  }

  const handle = getCartLineProductHandle(productLine);

  if (handle && mulberryShop?.getProductData) {
    try {
      const response = await mulberryShop.getProductData(`/products/${handle}`);

      if (response?.product) {
        return response.product;
      }
    } catch (error) {
      console.warn('Unable to fetch product detail for cart line:', error);
    }
  }

  return null;
}

async function buildMulberryProductPayload({
  productLine,
  productId,
  variantId,
  variantFromGraphql
}) {
  const price = getGraphqlVariantPrice(variantFromGraphql, productLine);
  const selectedOptionsLabel = getGraphqlSelectedOptionsLabel(variantFromGraphql);

  let productDetail = await getProductDetailForCartLine(productLine, productId);

  if (!productDetail) {
    productDetail = {
      id: Number(productId) || productId,
      product_id: Number(productId) || productId,
      title: productLine?.product_title || productLine?.title || '',
      handle: getCartLineProductHandle(productLine),
      vendor: productLine?.vendor || '',
      product_type: productLine?.product_type || '',
      variants: []
    };
  }

  const existingVariants = Array.isArray(productDetail.variants)
    ? productDetail.variants
    : [];

  const existingVariant = existingVariants.find((variant) => {
    return String(variant.id) === String(variantId);
  });

  const nextVariant = {
    ...(existingVariant || {}),
    id: Number(variantId) || variantId,
    title: selectedOptionsLabel || productLine?.variant_title || existingVariant?.title || '',
    price,
    sku: variantFromGraphql?.sku || productLine?.sku || existingVariant?.sku || '',
    available: variantFromGraphql?.availableForSale,
    options: (variantFromGraphql?.selectedOptions || []).map((option) => option.value)
  };

  const nextVariants = existingVariant
    ? existingVariants.map((variant) => {
        return String(variant.id) === String(variantId) ? nextVariant : variant;
      })
    : [...existingVariants, nextVariant];

  return {
    ...productDetail,
    id: productDetail.id || Number(productId) || productId,
    product_id: productDetail.product_id || Number(productId) || productId,
    title: productDetail.title || productLine?.product_title || productLine?.title || '',
    handle: productDetail.handle || getCartLineProductHandle(productLine),
    variantId: Number(variantId) || variantId,
    variants: nextVariants
  };
}

function findMatchingDurationOffer(newOffers, previousDurationMonths) {
  if (!Array.isArray(newOffers) || !newOffers.length) {
    return null;
  }

  if (!previousDurationMonths) {
    /**
     * Do not guess when multiple offers exist.
     * If only one new warranty exists, it is safe enough to use that.
     */
    return newOffers.length === 1 ? newOffers[0] : null;
  }

  return newOffers.find((offer) => {
    return Number(getWarrantyDurationMonthsFromOffer(offer)) === Number(previousDurationMonths);
  }) || null;
}

async function syncKachingCartAfterWarrantyChange() {
  try {
    if (window.kachingCartApi?.refreshCart) {
      await window.kachingCartApi.refreshCart();
    }

    if (window.kachingCartApi?.renderCart) {
      await window.kachingCartApi.renderCart();
    }
  } catch (error) {
    console.warn('Unable to refresh Kaching cart UI:', error);
  }
}

async function syncWarrantyForCartVariantChange({
  graphqlRequestBody,
  graphqlResponseBody
}) {
  const parsedRequest = safeJsonParse(graphqlRequestBody);

  const productGid = parsedRequest?.variables?.productId;
  const productId = extractShopifyNumericId(productGid);

  const variantFromGraphql =
    graphqlResponseBody?.data?.node?.variantBySelectedOptions;

  if (!productId || !variantFromGraphql?.id) {
    return;
  }

  const newVariantId = extractShopifyNumericId(variantFromGraphql.id);

  /**
   * If the new selected variant is unavailable, remove old warranty only.
   */
  const shouldAttachNewWarranty = variantFromGraphql.availableForSale !== false;

  isMulberryWarrantySyncing = true;

  try {
    /**
     * Step 1:
     * Read current cart before Kaching fully finishes replacing the variant.
     * This is where the old warranty is still available.
     */
    const cartBefore = await getCartJson();

    const oldParentLine = findParentProductLine(cartBefore, productId);
    const relatedWarrantyLines = findRelatedWarrantyLines(
      cartBefore,
      oldParentLine,
      productId
    );

    const previousWarrantyLine = relatedWarrantyLines[0] || null;
    const previousDurationMonths = getWarrantyDurationMonthsFromLine(previousWarrantyLine);

    /**
     * Step 2:
     * Remove previous attached warranty.
     */
    if (relatedWarrantyLines.length) {
      await removeWarrantyLines(relatedWarrantyLines);
    }

    /**
     * Step 3:
     * Wait until the cart line has become the newly selected variant.
     * If Kaching has not updated yet, we fallback to the old product line.
     */
    const {
      cartJson: cartAfterVariantChange,
      productLine: newParentLine
    } = await waitForCartVariant(productId, newVariantId, 4500);

    const productLineForPayload = newParentLine || oldParentLine;

    if (!productLineForPayload || !shouldAttachNewWarranty) {
      await syncKachingCartAfterWarrantyChange();
      return;
    }

    /**
     * Step 4:
     * Build Mulberry-compatible product payload for the new selected variant.
     */
    const productPayload = await buildMulberryProductPayload({
      productLine: productLineForPayload,
      productId,
      variantId: newVariantId,
      variantFromGraphql
    });

    mulberryShop.selectedVariantId = newVariantId;

    const variantPrice = getGraphqlVariantPrice(
      variantFromGraphql,
      productLineForPayload
    );

    /**
     * Step 5:
     * Ask Mulberry for warranty offers for the new selected variant.
     */
    const newOffers = await mulberry.core.getWarrantyOffer({
      id: newVariantId,
      title: productPayload.title,
      price: variantPrice,
      detail: productPayload,
    });

    if (!newOffers || !newOffers.length) {
      await syncKachingCartAfterWarrantyChange();
      return;
    }

    /**
     * Step 6:
     * Reattach only the same duration.
     * Example: old warranty was 60 months -> attach new 60 months warranty.
     */
    const matchingOffer = findMatchingDurationOffer(
      newOffers,
      previousDurationMonths
    );

    if (!matchingOffer) {
      await syncKachingCartAfterWarrantyChange();
      return;
    }

    const warrantyVariant = await mulberryShop.getWarrantyVariant(matchingOffer);

    if (!warrantyVariant?.shopify_variant_id) {
      await syncKachingCartAfterWarrantyChange();
      return;
    }

    await mulberryShop.addWarrantyToCart(
      warrantyVariant.shopify_variant_id,
      productPayload,
      matchingOffer
    );

    protectVariantWarrantySyncWindow();

    /**
     * Step 7:
     * Let Mulberry align warranty quantity with product quantity.
     */
    // try {
    //   const latestCart = await getCartJson();

    //   const cleanedCart = latestCart.items
    //     ? {
    //         ...latestCart,
    //         items: latestCart.items.filter(
    //           item => item?.properties?._variantId !== 'sectional'
    //         )
    //       }
    //     : latestCart;

    //   await mulberryShop.cart.syncQuantities(cleanedCart);
    // } catch (error) {
    //   console.warn('Unable to sync warranty quantities after variant change:', error);
    // }

    await syncKachingCartAfterWarrantyChange();
  } catch (error) {
    console.error('Error syncing warranty after cart variant change:', error);
  } finally {
    protectVariantWarrantySyncWindow();
    isMulberryWarrantySyncing = false;
  }
}

function queueCartVariantWarrantySync(payload) {
  const token = ++cartVariantWarrantySyncToken;

  cartVariantWarrantySyncQueue = cartVariantWarrantySyncQueue
    .catch(() => null)
    .then(async () => {
      /**
       * Small delay allows the cart widget to start its own cart/change flow.
       * The token prevents stale rapid variant changes from adding old warranties.
       */
      await wait(250);

      if (token !== cartVariantWarrantySyncToken) {
        return;
      }

      await syncWarrantyForCartVariantChange(payload);
    });
}

/**
 * -------------------------------------------------------------------------
 * FETCH LISTENER
 * -------------------------------------------------------------------------
 */

function setupFetchListeners() {
  if (window.__mulberryFetchPatched) return;
  window.__mulberryFetchPatched = true;

  const { fetch: origFetch } = window;

  window.fetch = async (...args) => {
    const requestInfo = await getFetchRequestInfo(args);

    const response = await origFetch(...args);

    const requestUrl = requestInfo.requestUrl || '';
    const requestBody = requestInfo.requestBody || '';

    /**
     * NEW:
     * Kaching cart variant dropdown calls Storefront GraphQL:
     * variantBySelectedOptions(selectedOptions: ...)
     *
     * When detected, remove old warranty and attach same-duration warranty
     * for the newly selected variant.
     */
    if (isVariantBySelectedOptionsRequest(requestUrl, requestBody)) {
      markCartVariantWarrantySyncPending();
      response
        .clone()
        .json()
        .then((graphqlResponseBody) => {
          queueCartVariantWarrantySync({
            graphqlRequestBody: requestBody,
            graphqlResponseBody
          });
        })
        .catch((err) => {
          console.error('Unable to process variantBySelectedOptions response:', err);
        });
    }

    const url = new URL(requestUrl, window.location.origin);
    const path = url.pathname;
    const isKachingCartUpdate = path === "/cart/update.js" && url.searchParams.get("kaching-cart") === "true";

    if (
      path === "/cart/change.js" ||
      path === "/cart/add.js" ||
      path === "/cart/update.js"
    ) {
      response
        .clone()
        .json()
        .then(() => {
          if (isMulberryWarrantySyncing || Date.now() < ignoreCartEventsUntil) {
            return;
          }

          if (
            isCartVariantWarrantySyncPending() &&
            (path === "/cart/update.js" || path === "/cart/change.js")
          ) {
            return;
          }

          if (isKachingCartUpdate) {
            const now = Date.now();

            if (now - lastKachingCartUpdateAt < KACHING_CART_UPDATE_COOLDOWN_MS) {
              return;
            }

            lastKachingCartUpdateAt = now;
          }

          if (path === "/cart/add.js") {
            document.dispatchEvent(new CustomEvent("fetch:cart-add"));
          } else if (path === "/cart/change.js") {
            document.dispatchEvent(new CustomEvent("fetch:cart-change"));
          } else if (path === "/cart/update.js") {
            document.dispatchEvent(new CustomEvent("fetch:cart-update"));
          }
        })
        .catch((err) => console.error(err));
    }
    return response;
  };
}

function getOptionValueFromCard(item) {
  return item.querySelector('.chiller-variant-item-title')?.textContent?.trim()
    || item.dataset.value?.trim()
    || '';
}

function normalize(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');
}

function updateVariantFromClickedOption(clickedOptionValue) {
  const variantInput = document
    .querySelector('.check-all-temp')
    ?.closest('form')
    ?.querySelector('[name="id"]');

  const productData = window.product || theProduct;

  if (variantInput && productData?.variants?.length) {
    const currentVariantId = Number(variantInput.value);
    const currentVariant = productData.variants.find(v => Number(v.id) === currentVariantId);

    if (currentVariant) {
      const clickedNormalized = normalize(clickedOptionValue);

      const optionIndex = productData.variants[0].options.findIndex((_, index) => {
        return productData.variants.some(variant => {
          return normalize(variant.options[index]) === clickedNormalized;
        });
      });

      if (optionIndex > -1) {
        const nextOptions = [...currentVariant.options];
        nextOptions[optionIndex] = clickedOptionValue;

        const matchedVariant = productData.variants.find(variant => {
          return variant.options.every((option, index) => {
            return normalize(option) === normalize(nextOptions[index]);
          });
        });

        if (matchedVariant) {
          variantInput.value = matchedVariant.id;
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));

          const url = new URL(window.location.href);
          url.searchParams.set('variant', matchedVariant.id);

          window.history.replaceState({}, '', url.toString());
        }
      }
    }
  }
}